module.exports = __webpack_public_path__ + "img/ring_r_l_1_null.aa1d71f9.png";